const navigationTechStatistics = [
  {
    title: true,
    name: "TECHNICAL STATISTICS",
    class: "",
    wrapper: {
      element: "",
      attributes: {}
    }
  },
  {
    name: "Active Backlog",
    url: "/base/Backlog",
    icon: "icon-layers"
  },
  {
    name: "Received Equipment",
    url: "/base/Received",
    icon: "icon-chart"
  },
  {
    name: "Analytics By Model",
    url: "/analyticsByModel",
    icon: "icon-chart"
  },
  {
    name: "Beyond Economical Repair",
    url: "/base/BER",
    icon: "icon-chart"
  },
  {
    name: "End Of Life",
    url: "/base/EOL",
    icon: "icon-chart"
  },
  {
    name: "No Trouble Found",
    url: "/base/NTF",
    icon: "icon-chart"
  },
  {
    name: "Under Warranty",
    url: "/base/WAR",
    icon: "icon-chart"
  },
  {
    name: "Turn Around Time",
    url: "/base/TAT",
    icon: "icon-chart"
  },
  {
    name: "OEM Repair",
    url: "/base/OemRepair",
    icon: "icon-chart"
  },
  {
    name: "Analytics by FNS office",
    url: "/base/Office",
    icon: "icon-chart"
  },
  {
    name: "FNS Office Charts",
    url: "/base/OfficeCharts",
    icon: "icon-chart"
  }
];

export default navigationTechStatistics;
